import "./component-modal.scss";
import { html } from "lit";
import ComponentBase from "./component-base";
import * as bootstrap from "bootstrap";

export const modalStates = {
  DISMISSED: "DISMISSED",
  SUBMITTED: "SUBMITTED",
};

class ComponentModal extends ComponentBase {
  static get tagName() {
    return "component-modal";
  }

  constructor(resolve, reject) {
    super();
    this.resolve = resolve;
    this.reject = reject;
    this.data = {};
    this.modalTitle = "Modal title";
    this.fullScreen = false;
    this.submitBtnText = "Invia";
    this.cancelBtnText = "Annulla";
    this.modalStatus = modalStates.DISMISSED;
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.modalStatus === modalStates.SUBMITTED) {
      this.resolve(this.data);
      return;
    }
    this.reject();
  }

  connectedCallback() {
    super.connectedCallback();
  }

  get classNames() {
    let _classNames = "";
    if (this.fullScreen) _classNames += " modal-fullscreen";
    return _classNames;
  }

  render() {
    return html`
      <div class="modal" tabindex="-1">
        <div class="modal-dialog ${this.classNames}">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">${this.modalTitle}</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">${this.modalBody}</div>
            <div class="modal-footer justify-content-between">
              ${this.modalFooter}
            </div>
          </div>
        </div>
      </div>
    `;
  }

  get modalBody() {
    return html` <p>Modal body text goes here.</p> `;
  }

  get modalFooter() {
    return html`
      <button
        @click=${this.OnCancel}
        type="button"
        class="btn btn-secondary btn-lg"
        data-bs-dismiss="modal"
      >
        ${this.cancelBtnText}
      </button>
      <button
        @click=${this._OnSubmit}
        type="button"
        class="btn btn-primary btn-lg"
      >
        ${this.submitBtnText}
      </button>
    `;
  }

  _OnSubmit() {
    this.modalStatus = modalStates.SUBMITTED;
    this.OnSubmit();
  }

  OnCancel() {}

  OnSubmit() {}

  Hide() {
    this.instance.hide();
  }

  firstUpdated() {
    this.modal = this.querySelector(".modal");
    this.modal.addEventListener("hidden.bs.modal", (evt) => {
      this.remove();
    });
    this.instance = new bootstrap.Modal(this.modal, {});
    this.instance.show();
  }

  static Show(...args) {
    return new Promise((resolve, reject) => {
      const modal = new this(resolve, reject, ...args);
      document.body.append(modal);
    });
  }
}
ComponentModal.Register();
export default ComponentModal;
